import { combineReducers, configureStore } from '@reduxjs/toolkit';
import resourcesApi from '@/slices/resources/resources.slice';

const reducers = combineReducers({
  [resourcesApi.reducerPath]: resourcesApi.reducer,
});

export const store = configureStore({
  reducer: reducers,
  middleware: (gDM) => gDM().concat([resourcesApi.middleware]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
